
define("tpl!drops/entityFiltersPanel/entityFiltersPanelItem.html", ["underscore"], function(_) { return function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="entity-filters-panel-item applied drop-text-container">\r\n    <span class="remove"></span>\r\n    <span class="settings"></span>\r\n    <span class="settings-ok-button"></span>\r\n    <div class="text-wrapper">\r\n        <span class="title drop-text-content">'+
((__t=( title ))==null?'':_.escape(__t))+
'</span>\r\n    </div>\r\n</div>';
}
return __p;
};});

